<h3 class="wf-peppol-detail-document-row__heading wf-text-sm-medium">
  {{ 'PEPPOL.Detail.DocumentSection' | translate }}
</h3>

@if (!documentId()) {
  <button
    wui-fill-button
    color="primary"
    class="wf-peppol-detail-document-row__cta"
    (click)="createDocumentRequested.emit()"
  >
    <wf-icon iconName="plus" iconClass="mini" />
    {{ 'PEPPOL.ACTIONS.CreateDocument' | translate }}
  </button>
} @else {
  <div class="wf-peppol-detail-document-row__box">
    @let documentKindLabel = 'DocType_' + documentKind() | translate;
    <span class="wf-peppol-detail-document-row__label wf-text-sm-medium">
      @if (documentNumber(); as documentNumber) {
        {{ documentNumber }} ({{ documentKindLabel }})
      } @else {
        {{ documentKindLabel }}
      }
    </span>

    @if (documentUrl(); as documentUrl) {
      <a
        wui-button
        icon
        class="wf-peppol-detail-document-row__action"
        target="_blank"
        [href]="documentUrl"
        [wuiTooltip]="'PEPPOL.Detail.OpenDocumentTooltip' | translate"
      >
        <wf-icon iconName="share_03" iconClass="mini" />
      </a>
    }
  </div>
}
